export default "__VITE_ASSET__Q2KzqICZ__"